import { AxiosRequestConfig } from '../types/index.ts';
import VerifyRequest from '../../verify_request.ts';
import { joinURL } from '../helpers/url.ts';

export default async function http(config: AxiosRequestConfig): Promise<void> {
  const { data = null, url = '', method = 'get', headers } = config;

  let body = data;
  let requestUrl = url;

  if (
    typeof VerifyRequest.baseURL === 'string' &&
    VerifyRequest.baseURL.length > 0
  ) {
    requestUrl = joinURL(VerifyRequest.baseURL, requestUrl);
  }

  // data 为null 时，不需要设置 Content - Type
  Object.keys(headers).forEach((name) => {
    if (data === null && name.toLowerCase() === 'content-type') {
      delete headers[name];
    }
  });

  try {
    const response = await fetch(requestUrl, {
      method: method.toUpperCase(),
      // credentials: 'include',
      headers: headers,
      body: method.toUpperCase() === 'GET' ? null : body,
    });

    if (!response.ok) {
      throw response.status;
    }

    return response.json();
  } catch (error) {
    console.error('Request failed: ', error);
    throw error;
  }
}
